<template>
  <div id="app">
    <topcomponents v-if="show"></topcomponents>
    <main class="cd-main-content">
      <router-view :key="key" />
      <webBottomcomponents v-if="show"></webBottomcomponents>
    </main>
  </div>
</template>

<script>
import topcomponents from "@/components/webTop/webxxTopMenu";
import webBottomcomponents from "@/components/webBottom/webxxBottom";
import { uuid } from "vue-uuid";
export default {
  name: "App",
  components: {
    topcomponents,
    webBottomcomponents,
    show:false
  },
  watch: {
    $route(to, from) {
       //console.log(to.name);
      if (to.name === "Login") {
        this.show=false;
      }
      else{
        this.show=true;
      }
    },
  },
  computed: {
    key() {
      let num =
        this.$route.name !== undefined
          ? this.$route.name + uuid.v1()
          : this.$route + uuid.v4();
      console.log(num);
      return num;
    },
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /*margin-top: 60px;*/
}
</style>



// WEBPACK FOOTER //
// src/App.vue